import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import "./PatientProgramDetails.css";
import moment from "moment";

const PatientProgramDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let { id } = useParams();
  let { program_id } = useParams();
  const [programData, setProgramData] = useState({});
  const [progressBar, setProgressBar] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    if (id !== undefined && program_id !== undefined) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/user_program_details", { id, program_id })
        .then((res) => {
          if (res.data.responseData) {
            let totalDays = res.data.responseData.totalDays;
            //let totalTasks = res.data.responseData.totalTasks;
            let daysDone = res.data.responseData.daysIn;
            //let completedTasks = res.data.responseData.completedTasks;
            let percentage = Math.ceil((daysDone * 100) / totalDays);
            if (percentage > 100) {
              percentage = 100;
            }
            setProgressBar(percentage);
            setProgramData(res.data.responseData);
            setDataLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id, program_id]);

  const handleRedirection = () => {
    const data = {
      from: "myPatients",
      pathname: location.pathname,
    };
    localStorage.setItem("previousLinks", JSON.stringify(data));
    navigate("/details/" + programData.programId);
  };
  return (
    <div className="patient_list_container patient_program_container">
      {dataLoaded ? (
        <>
          <div className="title_container_program_progress">
            <div className="title_progress">Progress</div>
            {/*<Link to={"/details/" + programData.programId} style={{ textDecoration: "none" }}>*/}
            <div className="view_program_btn" onClick={handleRedirection} style={{ cursor: "pointer" }}>
              View Program
            </div>
            {/*</Link>*/}
          </div>
          <div className="left_side_progress_popup">
            <div className="duration_workout">{programData.programName} progress</div>
            <div className="patient_program_progress">
              <div className="patient_list_progress_bar">
                <div
                  style={{
                    width: progressBar + "%",
                  }}
                  className="patient_list_progress_bar progress_done"
                ></div>
              </div>
            </div>
            <div className="start_and_end_date_container">
              <div className="start_date_progress">
                <div className="progress_informations_data">Start Date</div>
                <div className="changing_progress_data">{moment(programData.startDate).format("L")}</div>
              </div>
              <div className="end_date_progress">
                <div className="progress_informations_data">End Date</div>
                <div className="changing_progress_data">{moment(programData.endDate).format("L")}</div>
              </div>
            </div>
            <div>
              <div className="progress_days">
                <div className="progress_informations_data">Progress</div>
                <div className="changing_progress_data">
                  Day{" "}
                  {programData.daysIn >= programData.totalDays
                    ? programData.totalDays
                    : programData.daysIn > 0
                    ? programData.daysIn
                    : 0}{" "}
                  of {programData.totalDays}
                </div>
              </div>
              <div className="tasks_completed_of">
                <div className="progress_informations_data">Activities</div>
                <div className="changing_progress_data">
                  {programData.completedTasks} activities completed of {programData.totalTasks}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="p_load"></div>
      )}
    </div>
  );
};
export default PatientProgramDetails;
